let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1348y")).then(() => parcelRequire('bVzld'));